export default __webpack_public_path__ + "static/funcionamiento-icono-2-df024080f961ae2f1e8f0089a2194d2b.png";